// extracted by mini-css-extract-plugin
module.exports = {"text":"text-module--text--3Xk7F","textFeatured":"text-module--text--featured--3pF90"};